import { ReactElement } from 'react';

import { MedicalField } from '@dreryk/egabinet-healthcare-provider-frontend-api';
import { VisitLocation } from '@dreryk/egabinet-visit-frontend-api';

import { Select, StyledFlex } from '@dreryk/react-components';
import { BindingCreator, createTranslatedText } from '@dreryk/react-common';

import { dischargeSummaryTranslationKeys } from '../../../../translations';
import { DischargeSummaryFormController } from '../../DischargeSummaryForm.types';

import {
   createMedicalDepartmentsSearchCreator,
   medicalDepartmentFilterCreator,
   triggerLabelExtractor,
} from './MedicalDepartmentField.utils';
import { MedicalDepartmentFieldMissingDepartmentNotification } from './MedicalDepartmentFieldMissingDepartmentNotification';

type MedicalDepartmentFieldFormBeanPart = {
   medicalDepartment: MedicalField | null;
};

type MedicalDepartmentFieldProps = Pick<DischargeSummaryFormController, 'watch' | 'setValue'> & {
   visitLocation: VisitLocation;
   register: BindingCreator<MedicalDepartmentFieldFormBeanPart, 'medicalDepartment'>;
};

// eslint-disable-next-line max-lines-per-function
export const MedicalDepartmentField = (props: MedicalDepartmentFieldProps): ReactElement => {
   return (
      <StyledFlex gap={'8px'} direction={'column'}>
         <Select<MedicalField>
            testId={'medicalDepartment'}
            triggerLabelExtractor={triggerLabelExtractor}
            controller={props.register('medicalDepartment', { required: true })}
            placeholder={dischargeSummaryTranslationKeys.chooseMedicalDepartmentCode}
            label={dischargeSummaryTranslationKeys.documentGeneratingWithinMedicalField}
            searchInputEnabled
         >
            <Select.SearchCreator
               searchCreator={createMedicalDepartmentsSearchCreator(props.visitLocation)}
               displayNoResultsMessage={false}
            >
               {({ items }) => (
                  <Select.Filter
                     items={items}
                     filter={medicalDepartmentFilterCreator}
                     noResultsMessage={dischargeSummaryTranslationKeys.noDepartmentCodes}
                  >
                     {({ filteredItems }) => (
                        <Select.List items={filteredItems} keyExtractor={'id'}>
                           {(medicalField) => (
                              <Select.Item<MedicalField>
                                 testId={medicalField.code}
                                 item={medicalField}
                                 label={createTranslatedText(`${medicalField.code} ${medicalField.name}`)}
                              />
                           )}
                        </Select.List>
                     )}
                  </Select.Filter>
               )}
            </Select.SearchCreator>
         </Select>
         <MedicalDepartmentFieldMissingDepartmentNotification />
      </StyledFlex>
   );
};
